import { jsx as _jsx } from "react/jsx-runtime";
import { ContentSectionWithIcon } from "@cinch-labs/design-system";
import React from "react";
import styles from "./our-commitment-slide.module.css";
const OurCommitmentSlide = ({ iconName , backgroundColor , title , body  })=>/*#__PURE__*/ _jsx("div", {
        style: {
            backgroundColor
        },
        className: styles["ourCommitmentSlideContainer"],
        children: /*#__PURE__*/ _jsx(ContentSectionWithIcon, {
            sectionWrapperClass: styles["ourCommitmentSlide"],
            iconName: iconName,
            iconColor: "goGreen",
            title: title,
            classNames: {
                title: styles["title"],
                body: styles["body"]
            },
            children: /*#__PURE__*/ _jsx("p", {
                dangerouslySetInnerHTML: {
                    __html: body
                }
            })
        })
    });
export default OurCommitmentSlide;
